import { useEffect, useMemo, useRef } from "react";
import { useParticipant } from "@videosdk.live/react-sdk";
import { Tag } from "antd";
import { nameTructed } from "../../utils/common";

const DisplayName = ({
  participantId,
  displayName,
  isLocal,
  mouseOver,
}: {
  participantId: string,
  displayName: string,
  isLocal: boolean,
  mouseOver?: boolean,
}) => {
  const show = useMemo(() => mouseOver, [mouseOver]);

  const {
    webcamStream,
    micStream,
    screenShareStream,
  } = useParticipant(participantId);

  const statsIntervalIdRef = useRef<ReturnType<typeof setInterval> | null>(null);

  useEffect(() => {
    if (webcamStream || micStream || screenShareStream) {
      if (statsIntervalIdRef.current) {
        clearInterval(statsIntervalIdRef.current);
      }
    } else if (statsIntervalIdRef.current) {
      clearInterval(statsIntervalIdRef.current);
      statsIntervalIdRef.current = null;
    }

    return () => {
      if (statsIntervalIdRef.current) clearInterval(statsIntervalIdRef.current);
    };
  }, [webcamStream, micStream, screenShareStream]);

  return (
    <Tag
      style={{
        position: "absolute",
        left: 16,
        bottom: 16,
        transition: "all 200ms",
        transitionTimingFunction: "linear",
        transform: `scale(${show ? 1 : 0})`,
      }}
    >
      {isLocal ? "You" : nameTructed(displayName, 26)}
    </Tag>
  );
};

export default DisplayName;
